import { DBSchema, openDB } from 'idb';

import { isBrowser } from '@utils/isBrowser';

export type DataStoreTypes = 'user' | 'name';

export interface IUser {
	avatar: string;
	identification: string;
	email: string;
	stateOfResidence: string;
	tempPassword?: string;
	preferredFirstName?: string;
	preferredLastName?: string;
	legalFirstName?: string;
	legalLastName?: string;
}

interface ILocalDbSchema extends DBSchema {
	user: {
		value: IUser;
		key: 'user';
	};
}

const localDb = 'local-db';

const dbPromise =
	isBrowser &&
	openDB<ILocalDbSchema>(localDb, 1, {
		upgrade(db) {
			// Repeat for all top level stores in LocalDbSchema
			db.createObjectStore('user');
		},
	});

export const get = async (dataStore: DataStoreTypes, key?: IDBKeyRange): Promise<IUser> => {
	const dataKey: IDBKeyRange | DataStoreTypes = key ?? dataStore;
	return (await dbPromise).get(dataStore, dataKey);
};

export const update = async (
	dataStore: DataStoreTypes,
	value: Record<string, any>,
	key?: IDBKeyRange
): Promise<IUser> => {
	const dataKey: IDBKeyRange | DataStoreTypes = key ?? dataStore;
	const existingData = await get(dataStore, key);
	return (await dbPromise).put(dataStore, { ...existingData, ...value }, dataKey);
};

export const deleteDataStore = async (
	dataStore: DataStoreTypes,
	key?: IDBKeyRange
): Promise<IUser> => {
	const dataKey: IDBKeyRange | DataStoreTypes = key ?? dataStore;
	return (await dbPromise).delete(dataStore, dataKey);
};

/** User methods */

export const getLocalUser = (): Promise<IUser> => get('user');
export const updateLocalUserAvatar = (avatar: string): Promise<IUser> => update('user', { avatar });
export const updateLocalUserId = (identification: string): Promise<IUser> =>
	update('user', { identification });
